import { useApiMutation } from "./use-api-mutation";
import { invalidateAllShopEmailTemplatesKey } from "./use-get-all-shop-email-templates";
import { invalidateAllReturnWorkflowsKey } from "./use-get-all-return-workflows";
import type { BulkDeleteReturnWorkflowsDto } from "../generated/schema";

export default function useBulkDeleteReturnWorkflows(shopId: string) {
	return useApiMutation("delete", "/shops/{shopId}/return-workflows/bulk", {
		notify: false,
		meta: {
			success: {
				title: "workflows.editor.delete.success.title",
				message: "workflows.editor.delete.success.message",
			},
			error: {
				title: "workflows.editor.delete.error.title",
				message: "workflows.editor.delete.error.message",
			},
			invalidatesQuery: [
				invalidateAllReturnWorkflowsKey(shopId),
				invalidateAllShopEmailTemplatesKey(shopId),
			],
		},
		mapVariables: ({
			requestBody,
		}: { requestBody: BulkDeleteReturnWorkflowsDto }) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
